import { atom } from "recoil";

const tutorialPopUpAtom = atom({
  key: "tutorialPopUp",
  default: false,
});

export default tutorialPopUpAtom;
